module.exports = __webpack_public_path__ + "img/在未来的医学概念的男医生.287073e8.jpg";